var map = {
	"./ClearInventoryItemQuantity/ClearInventoryItemQuantityMutatorEditor": 1979,
	"./CopyInventoryItem/CopyInventoryItemMutatorEditor": 1980,
	"./InventoryItem/InventoryItemMutatorEditor": 1981,
	"./List/ListMutatorEditor": 1982,
	"./Replace/ReplaceMutatorEditor": 1983,
	"./Vary/VaryMutatorEditor": 1984
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1978;